import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextEditorComponent } from './text-editor.component';
import { FiContenteditableModelModule } from '../contenteditable-model/contenteditable-model.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiReplaceWithLinksModule } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.module';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { TextEditorInsertMediaService } from './text-editor-insert-media.service';
import { OperationOverlaySmallModule } from '../operation-overlay-small/operation-overlay-small.module';
import { TextEditorInsertEmbedCodeService } from './text-editor-insert-embed-code.service';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FormsModule } from '@angular/forms';
import { FiDisableLinksModule } from '@fi-shared/fi-directives/disable-links/disable-links.module';
import { FiTextEditorSharedModule } from '@fi-shared/fi-text-editor/fi-text-editor-shared.module';
import { MatButtonModule } from '@angular/material/button';
import { FiGiphyModule } from '@fi-shared/fi-giphy/fi-giphy.module';
import { FiTextEditorInsertEmbedCodeDialogComponent } from '@fi-shared/text-editor/text-editor-insert-embed-code-dialog/text-editor-insert-embed-code-dialog.component';
import { FiDirectivesModule } from '@fi-shared/fi-directives/fi-directives.module';
import { MatIcon } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiContenteditableModelModule,
        FiAppTextSharedModule,
        FiReplaceWithLinksModule,
        FiAutofocusModule,
        OperationOverlaySmallModule,
        FiProfileIconModule,
        FiLoadingModule,
        FiTextEditorSharedModule,
        FiDisableLinksModule,
        FiDirectivesModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatMenuModule,
        FiGiphyModule,
        MatIcon,
    ],
    declarations: [TextEditorComponent, FiTextEditorInsertEmbedCodeDialogComponent],
    exports: [TextEditorComponent, FiTextEditorSharedModule],
    providers: [TextEditorInsertMediaService, TextEditorInsertEmbedCodeService],
})
export class FiTextEditorModule {}
